import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchEquipmentTypes = () => api.get('/equipment-type/search').then((res) => res.data);

export default function useEquipmentTypes() {
  return useQuery('equipmentTypes', fetchEquipmentTypes);
}